<span
    *ngIf="severity && severityData"
    class="pstg-secondary-icon {{ severityData.class }}"
    [ngClass]="{ disabled: isDisabled }"
>
    <pureui-svg [svg]="severityData.svg" [height]="iconHeight" [width]="iconWidth"></pureui-svg>
</span>
